module.exports = __webpack_public_path__ + "static/img/promotion2.d9c37d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/promotion2.png
// module id = LLUx
// module chunks = 1